const PERF_KEY = "lap_legends_perf_tier";

export function getStoredPerfTier() {
  return localStorage.getItem(PERF_KEY); // 'high' | 'medium' | 'low' | null
}

export function storePerfTier(tier) {
  localStorage.setItem(PERF_KEY, tier);
}

export async function runPerfBenchmark({ durationMs = 10000 } = {}) {
  return new Promise((resolve) => {
    const samples = [];
    let lastTime = 0;
    const startTime = performance.now();

    function loop(now) {
      if (!lastTime) {
        lastTime = now;
        requestAnimationFrame(loop);
        return;
      }

      const dt = now - lastTime;
      lastTime = now;

      const fps = 1000 / dt;
      samples.push(fps);

      if (now - startTime < durationMs) {
        requestAnimationFrame(loop);
      } else {
        resolve(samples);
      }
    }

    requestAnimationFrame(loop);
  });
}

export function classifyPerf(samples) {
  if (!samples.length) return "low";

  const sorted = samples.slice().sort((a, b) => a - b);
  const median = sorted[Math.floor(sorted.length / 2)];
  const p10 = sorted[Math.floor(sorted.length * 0.1)]; // 10th percentile

  // Tweak these thresholds to taste:
  if (median >= 58 && p10 >= 50) return "high"; // solid 60-ish
  if (median >= 40 && p10 >= 30) return "medium"; // playable but not 60
  return "low";
}
